import {
  DynamicLinkType,
  FlexibleBlockBrickTiles,
  FlexibleBlockBrickTileItem,
  FlexibleBlockProps,
  FlexibleBlockTemplateTiles,
  PortalTextType,
  PortalBgType,
  PortalBorderType,
  FlexibleBlockBrickText,
} from '@nx-frontend/shared/types';
import { ThemeColorConfig } from '@nx-frontend/shared/types/theme';
import { getWrapperProps } from '@nx-frontend/shared/utils';
import { brickCommon } from './common';

export const getTilesBlockTemplateItems = (): FlexibleBlockBrickTileItem[] => {
  let itemIndex = -1;
  const defaultTheme: ThemeColorConfig<'main' | 'hover', 'main', 'main'> = {
    bg: { main: PortalBgType.SURFACE_INNER, hover: PortalBgType.SURFACE_INNER_HOVER },
    text: { main: PortalTextType.SURFACE },
    border: { main: PortalBorderType.SURFACE_INNER },
  };
  return [
    {
      index: ++itemIndex,
      title: 'Meeting Notes',
      image: '/assets/img/blocks/card-group/calendar.png',
      dynamicLink: { type: DynamicLinkType.EXTERNAL, url: 'https://en.wikipedia.org/wiki/Presentation' },
      theme: defaultTheme,
    },
    {
      index: ++itemIndex,
      title: 'Invoices',
      image: '/assets/img/blocks/card-group/book.png',
      dynamicLink: { type: DynamicLinkType.EXTERNAL, url: 'https://en.wikipedia.org/wiki/Invoice' },
      theme: defaultTheme,
    },
    {
      index: ++itemIndex,
      title: 'For Review',
      image: '/assets/img/blocks/card-group/pen.png',
      dynamicLink: { type: DynamicLinkType.EXTERNAL, url: 'https://en.wikipedia.org/wiki/New_product_development' },
      theme: defaultTheme,
    },
    {
      index: ++itemIndex,
      title: 'Business',
      image: '/assets/img/blocks/card-group/briefcase.png',
      dynamicLink: { type: DynamicLinkType.EXTERNAL, url: 'https://en.wikipedia.org/wiki/Project' },
      theme: defaultTheme,
    },
  ];
};

export const getTilesBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateTiles>[] => {
  let index = 0;

  const brickDescription: FlexibleBlockBrickText = {
    ...brickCommon,
    brickType: 'text',
    brickName: 'Description',
    switchable: true,
    placeholder: 'Here, you can add some information about widget',
    text: 'Quick Links Widget: Easily create a customizable group of cards featuring images, titles, and links.',
    theme: {
      text: {
        main: PortalTextType.SURFACE,
      },
    },
    index: index++,
  };

  const BrickTiles: FlexibleBlockBrickTiles = {
    ...brickCommon,
    brickType: 'tiles',
    brickName: 'Card group',
    items: getTilesBlockTemplateItems(),
    className: ['justify-start', '-m-2', '*:p-2'],
    index: index++,
  };

  return [
    {
      title: 'Card group',
      template: {
        type: 'tiles',
        view: 'basic',
      },
      bricks: [brickDescription, BrickTiles],
      wrapper: getWrapperProps('blank'),
      className: [],
    },
  ];
};
